import { Table, Typography } from 'antd';

const getEligibilityText = (isEligible) => {
  if (isEligible === true) {
    return 'Pass';
  }
  if (isEligible === false) {
    return 'Fail';
  }
  return '--';
};

const EligibilityTable = ({ eligible, eligibilityChecks }) => {
  const columns = [
    {
      dataIndex: 'name',
      key: 'name',
      render: (value) => <Typography.Text>{value}</Typography.Text>,
    },
    {
      dataIndex: 'pass',
      key: 'pass',
      width: '10%',
      render: (isEligible) => {
        return (
          <Typography.Text strong type={isEligible ? 'success' : 'warning'}>
            {getEligibilityText(isEligible)}
          </Typography.Text>
        );
      },
    },
  ];

  const dataSource = eligibilityChecks?.map((check) => {
    return { ...check, key: check.name };
  });

  return (
    <>
      {eligible != undefined && (
        <Typography.Paragraph strong>
          Eligibility:{' '}
          <Typography.Text type={eligible ? 'success' : 'warning'}>
            {eligible ? 'Eligible' : 'Ineligible'}
          </Typography.Text>
        </Typography.Paragraph>
      )}

      <Table
        columns={columns}
        dataSource={dataSource}
        bordered={true}
        size="small"
        pagination={false}
        showHeader={false}
      />
    </>
  );
};
export default EligibilityTable;
